<template>
  <Carousel
    :items-to-show="
      carouselLength > 2 ? (isWindowSmall ? 2 : 3) : carouselLength
    "
    :itemsToScroll="isWindowSmall ? 1 : carouselLength > 3 ? 3 : 1"
    :wrapAround="false"
  >
    <Slide
      v-for="carouselCard in $store.state.products.carouselCards.slice(
        0,
        maxProducts
      )"
      :key="carouselCard.id"
    >
      <div class="carousel__card-wrapper" v-if="!loading">
        <ProductCard
          :productCard="carouselCard"
          :showCategory="false"
          @click="goToProduct(carouselCard.id)"
          @keyup.enter="goToProduct(carouselCard.id)"
        />
      </div>
      <div class="row d-flex justify-content-center" v-if="loading">
        <div
          class="spinner-border m-5"
          role="status"
          style="color: var(--deepgreen); width: 5rem; height: 5rem"
        ></div>
      </div>
    </Slide>

    <template #addons>
      <Navigation
        v-if="
          carouselLength > 3
            ? true
            : isWindowSmall && carouselLength == 3
            ? true
            : false
        "
      />
      <Pagination
        v-if="
          carouselLength > 3
            ? true
            : isWindowSmall && carouselLength == 3
            ? true
            : false
        "
      />
    </template>
  </Carousel>
</template>

<script>
import ProductCard from "@/components/products/ProductCard.vue";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default {
  props: {
    isWindowSmall: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    maxProducts: {
      type: Number,
      default: 12,
    },
  },
  components: {
    ProductCard,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      carouselLength: this.$store.state.products.carouselCards.slice(
        0,
        this.maxProducts
      ).length,
    };
  },
  methods: {
    goToProduct(id) {
      this.$router.push({
        name: "ProductInfo",
        params: { productId: id },
      });
    },
  },
};
</script>

<style>
.carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.carousel__slide {
  padding: 10px;
  align-items: flex-start;
}
.carousel__prev,
.carousel__next {
  background-color: var(--deepgreen);
  box-sizing: content-box;
  border: 5px solid white;
}
.carousel__pagination {
  padding-left: 0 !important;
}
.carousel__pagination-button {
  background-color: var(--mediumgreen);
}
.carousel__pagination-button--active {
  background-color: var(--deepgreen);
}
.carousel__slide .carousel__card-wrapper {
  width: 100%;
}
</style>
